import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/demandes");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#2C2C2C] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-2xl bg-[#FAF6EF] p-8 shadow-2xl">
        <div className="mb-6 text-center">
          <img src="/afroregal-logo.webp" alt="Afro Regal" className="mx-auto h-20 w-auto" />
          <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#C9A84C]">Administration</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm text-[#2C2C2C]">E-mail</label>
            <input type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full rounded-lg border border-[#2C2C2C]/20 bg-white px-4 py-2.5 text-sm outline-none focus:border-[#C9A84C] focus:ring-1 focus:ring-[#C9A84C]" />
          </div>
          <div>
            <label className="mb-1 block text-sm text-[#2C2C2C]">Mot de passe</label>
            <input type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full rounded-lg border border-[#2C2C2C]/20 bg-white px-4 py-2.5 text-sm outline-none focus:border-[#C9A84C] focus:ring-1 focus:ring-[#C9A84C]" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#2C2C2C] py-3 text-sm text-white transition-colors hover:bg-[#C9A84C] hover:text-[#2C2C2C] disabled:opacity-60">
            {loading && <Loader2 size={16} className="animate-spin" />} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
